import { useState, useEffect } from "react";
import Navigation from "../../../components/navbar";
import { Container, Row } from "react-bootstrap";
import Footer from "../../../components/footer";
import { toast } from "react-toastify";
import { useGetResumeApplicantsData } from "../../../hooks/apis/useResumeClinic.api";
import ResumeSummary from "../../../components/event-rsvp/resume-clinic/admin-resume-clinic/ResumeSummary";
import ResponsiveResumeTable from "../../../components/event-rsvp/resume-clinic/admin-resume-clinic/ResponsiveResumeTable";















const AdminResumeClinic = () => {
  const { data, status, error } = useGetResumeApplicantsData();
  const [title] = useState("Resume Clinic | Eraconneckt");

  useEffect(() => {
    if (status === "error") {
      toast.error(error?.response?.data?.error || "Failed to fetch RSVP data.");
      console.error(error?.message);
    }
  }, [status, error, data]);

  useEffect(() => {
    // This will run when the page first loads and whenever the title changes
    document.title = title;
  }, [title]);

  return (
    <>
      <Navigation />
      <Container>
        <Row style={{ marginTop: "100px" }}>
          <ResumeSummary data={data || []} />
        </Row>

        <Row>
          <ResponsiveResumeTable data={data?.data || []} />
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default AdminResumeClinic;
